"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_FEATURE_BUY = exports.SHOW_FEATURE_BUY_BUTTON = exports.SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET = exports.REQUEST_FEATURE_BUY_TOGGLE = exports.OPEN_FEATURE_BUY = exports.HIDE_FEATURE_BUY_BUTTON = exports.FEATURE_BOUGHT = exports.CLOSE_FEATURE_BUY = exports.BUY_FEATURE = void 0;
var BUY_FEATURE = exports.BUY_FEATURE = "BUY_FEATURE";
var FEATURE_BOUGHT = exports.FEATURE_BOUGHT = "FEATURE_BOUGHT";

/** StateChange */
var OPEN_FEATURE_BUY = exports.OPEN_FEATURE_BUY = "OPEN_FEATURE_BUY";
var CLOSE_FEATURE_BUY = exports.CLOSE_FEATURE_BUY = "CLOSE_FEATURE_BUY";
var TOGGLE_FEATURE_BUY = exports.TOGGLE_FEATURE_BUY = "TOGGLE_FEATURE_BUY";
/** Request that are validated */
var REQUEST_FEATURE_BUY_TOGGLE = exports.REQUEST_FEATURE_BUY_TOGGLE = "REQUEST_FEATURE_BUY_TOGGLE";

/**Show */
var SHOW_FEATURE_BUY_BUTTON = exports.SHOW_FEATURE_BUY_BUTTON = "SHOW_FEATURE_BUY_BUTTON";
var HIDE_FEATURE_BUY_BUTTON = exports.HIDE_FEATURE_BUY_BUTTON = "HIDE_FEATURE_BUY_BUTTON";
var SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET = exports.SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET = "SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET";
//# sourceMappingURL=types.js.map